import { Component, effect, inject } from '@angular/core';
import { TrimInputDirective } from 'src/app/directives/trim.directive';
import { GeneralSettingsFormService } from '../../../services/general-settings-form.service';
import { FiscalPrinterForm, GeneralSettingsFields } from '../../../models/settings-printers.model';
import { CustomFormGroup } from '@tilby/tilby-ui-lib/components/tilby-magic-form';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CardComponent } from 'src/app/shared/components/master-detail-layout/card/card.component';
import { TranslateModule } from '@ngx-translate/core';
import { PrintersModuleService } from '../../../services/printers-module.service';

@Component({
  selector: 'app-fiscal-settings',
  standalone: true,
  imports: [
    CommonModule,
    TrimInputDirective,
    CardComponent,
    MatFormFieldModule, ReactiveFormsModule,
    MatInputModule, MatSelectModule, MatSlideToggleModule,
    TranslateModule
  ],
  templateUrl: './fiscal-settings.component.html',
  styleUrl: './fiscal-settings.component.scss'
})
export class FiscalSettingsComponent {
  
  protected readonly generalSettingsformService = inject(GeneralSettingsFormService);
  private readonly printerModuleService = inject(PrintersModuleService);

  protected fiscalGroupForm!: CustomFormGroup<FiscalPrinterForm>;
  protected settings: GeneralSettingsFields | null = null;

  headerControls = this.buildHeaderControls();

  constructor() {
    effect(() => {
      if(this.generalSettingsformService.generalSettingsFormReady()) {
        this.fiscalGroupForm = this.generalSettingsformService.fiscalGroup;
        // the form can be recreated by the service: keep the header controls bound to the live one
        this.headerControls = this.buildHeaderControls();
      }
    });
    effect(() => {
      this.settings = this.printerModuleService.selection()?.generalSettings as GeneralSettingsFields;
    });
  }

  private buildHeaderControls() {
    return Array.from({ length: 13 }, (_, i) => this.generalSettingsformService.getPrinterHeader(i + 1));
  }

}
